import {
    useBillableUnitQuery,
    useCreateBillableUnitMutation,
    useUpdateBillableUnitMutation,
} from './useBillableUnitsQuery';
import {BillableUnit} from '../types';

// Single-record hook. createRecord / updateRecord return the mutation PROMISE
// (mutateAsync), so a drawer can await the server before it closes and stay open
// when the server refuses (§6, §7). The mutation's onError toasts the refusal.
export const useBillableUnit = (billableUnitId?: string) => {
    const query = useBillableUnitQuery(billableUnitId);
    const createMutation = useCreateBillableUnitMutation();
    const updateMutation = useUpdateBillableUnitMutation();

    const updateRecord = (values: BillableUnit) => {
        if (!billableUnitId) {
            return Promise.reject(new Error('billableUnitId is required parameter'));
        }
        return updateMutation.mutateAsync({id: billableUnitId, values});
    };

    return {
        record: query.data,
        loading: query.isLoading,
        createRecord: createMutation.mutateAsync,
        updateRecord,
        isPending: createMutation.isPending || updateMutation.isPending,
    };
};
